<template lang="pug">
  b-modal#modal-edit-order-note(centered, size="ml", @hide="hide", :no-close-on-backdrop="isLoading", :no-close-on-esc="isLoading")
    //- header
    template(#modal-header="{cancel}")
      | メモを編集
      button.close(title="閉じる", @click="cancel", :disabled="isLoading") ×
    //- body
    template(#default)
      b-form-textarea(v-model="order_note", maxlength="512", rows="5")
      b-form-text.error-message-color(v-if="error_msg !== ''") {{error_msg}}
    //- footer
    template(#modal-footer="{ ok, cancel }")
      b-button(variant="outline-secondary", size="sm", @click="cancel", :disabled="isLoading") キャンセル
      b-button(variant="primary", size="sm", @click="updateOrderNote", :disabled="isLoading") 保存

</template>

<script>
import Api from "@/repositories/api"
const S210OrderHistoryRepository = Api.get("s210OrderHistory")

export default {
  name: 'ModalEditOrderNote',
  props: {
    order_info: { type: Object, required: true }
  },
  data () {
    return {
      // 受注番号
      accept_no: "",

      // メモ
      order_note: "",

      // ローディングフラグ
      isLoading: false,

      // エラーメッセージ
      error_msg: ""
    }
  },
  watch: {
    order_info (newVal) {
      this.accept_no = newVal.accept_no
      this.order_note = newVal.order_note
    }
  },
  methods: {
    /**
     * メモを更新する
     */
    updateOrderNote () {
      // ローディング開始
      this.isLoading = true

      // エラーメッセージをリセットする
      this.resetError()

      // メモ編集処理を実行する
      S210OrderHistoryRepository.edit(this.accept_no, this.order_note)
        .then(() => {
          // ダイアログを閉じる
          this.$bvModal.hide('modal-edit-order-note')

          // S21001_お申込み履歴表示処理を実行する
          this.$emit('getOrderHistory')
        })
        .catch((error) => {
          // 共通のエラー処理
          this.apiError(error, "メモ更新処理")

          // バリデーションエラー
          if (error.response.data.error_list) {
            // エラーメッセージをセット
            this.error_msg = error.response.data.error_list[0].error_msg;
          }
        })
        .finally(() => {
          // ローディング終了
          this.isLoading = false
        })
    },
    /**
     * エラーメッセージをリセットする
     */
    resetError () {
      this.error_msg = ""
    },
    /**
     * ダイアログを閉じたときの処理
     */
    hide () {
      this.error_msg = ""
    }
  }
}
</script>
